(() => {
  const initialiseMegaMenuItem = (item) => {
    if (item.dataset.legalMegaItemInitialised === 'true') return;
    item.dataset.legalMegaItemInitialised = 'true';

    const trigger = item.querySelector('[data-legal-mega-trigger]');
    const menu = item.querySelector('.legal-mega-menu');
    const closeButton = item.querySelector('[data-legal-mega-close]');
    if (!trigger || !menu) return;

    const categories = [...menu.querySelectorAll('[data-legal-mega-category]')];
    const panels = [...menu.querySelectorAll('[data-legal-mega-panel]')];
    const cardsContainer = menu.querySelector('.legal-mega-menu__cards');
    const cards = [...menu.querySelectorAll('[data-legal-mega-card-category]')];
    const videos = [...menu.querySelectorAll('[data-legal-mega-video]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const prepareVideo = (video) => {
      if (video.src) return;
      video.src = video.dataset.src;
      video.load();
    };
    const stopVideos = () => {
      videos.forEach((video) => {
        video.pause();
        try { video.currentTime = 0; } catch (_) { /* Source has not loaded yet. */ }
        video.setAttribute('aria-pressed', 'false');
      });
    };
    const playVideo = (video, { explicit = false } = {}) => {
      if (!video || document.hidden || video.closest('[hidden]')) return;
      prepareVideo(video);
      if (reducedMotion.matches && !explicit) return;
      videos.forEach((other) => {
        if (other !== video) {
          other.pause();
        }
      });
      if (video.ended) video.currentTime = 0;
      video.muted = true;
      video.play().catch(() => video.setAttribute('aria-pressed', 'false'));
    };
    videos.forEach((video) => {
      const card = video.closest('.legal-mega-menu__card');
      video.addEventListener('loadedmetadata', () => {
        if (video.paused && video.duration > 0.01) video.currentTime = 0.01;
      });
      video.addEventListener('playing', () => video.setAttribute('aria-pressed', 'true'));
      video.addEventListener('pause', () => video.setAttribute('aria-pressed', 'false'));
      video.addEventListener('ended', () => video.setAttribute('aria-pressed', 'false'));
      card?.addEventListener('pointerenter', () => playVideo(video));
      card?.addEventListener('focusin', () => playVideo(video));
      video.addEventListener('click', () => {
        if (video.paused) playVideo(video, { explicit: true });
        else video.pause();
      });
      video.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (video.paused) playVideo(video, { explicit: true });
        else video.pause();
      });
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopVideos();
    });
    reducedMotion.addEventListener?.('change', () => {
      if (reducedMotion.matches) stopVideos();
    });
    const selectCategory = (index) => {
      const activeCategory = categories.find((category) => category.dataset.legalMegaCategory === index);
      categories.forEach((category) => {
        const selected = category.dataset.legalMegaCategory === index;
        category.classList.toggle('is-selected', selected);
        category.setAttribute('aria-expanded', String(selected));
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.legalMegaPanel !== index;
      });
      if (cardsContainer && activeCategory) {
        const label = activeCategory.dataset.legalMegaCategoryTitle.trim().toLocaleLowerCase();
        const targetedCards = cards.filter((card) => card.dataset.legalMegaCardCategory.trim().toLocaleLowerCase() === label);
        let visibleCount = 0;
        cards.forEach((card) => {
          const target = card.dataset.legalMegaCardCategory.trim();
          card.hidden = targetedCards.length ? !targetedCards.includes(card) : target !== '';
          if (!card.hidden) visibleCount += 1;
        });
        videos.filter((video) => video.closest('.legal-mega-menu__card')?.hidden).forEach((video) => {
          video.pause();
        });
        cardsContainer.hidden = visibleCount === 0;
        cardsContainer.classList.toggle('legal-mega-menu__cards--1', visibleCount === 1);
        menu.querySelector('.legal-mega-menu__layout')?.classList.toggle('legal-mega-menu__layout--no-cards', visibleCount === 0);
      }
    };

    categories.forEach((category) => {
      category.addEventListener('pointerenter', () => selectCategory(category.dataset.legalMegaCategory));
      category.addEventListener('focus', () => selectCategory(category.dataset.legalMegaCategory));
    });
    const currentCategory = categories.find((category) => category.classList.contains('is-active'));
    if (currentCategory) selectCategory(currentCategory.dataset.legalMegaCategory);
    else if (categories[0]) selectCategory(categories[0].dataset.legalMegaCategory);

    let openTimer;
    let closeTimer;

    const setExpanded = (expanded) => {
      trigger.setAttribute('aria-expanded', String(expanded));
      menu.setAttribute('aria-hidden', String(!expanded));
    };

    const open = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      const wasOpen = item.classList.contains('is-open');
      item.classList.add('is-open');
      item.classList.remove('is-closed');
      setExpanded(true);
      if (!wasOpen) {
        playVideo(videos.find((video) => !video.closest('.legal-mega-menu__card')?.hidden));
      }
    };

    const close = ({ restoreFocus = false } = {}) => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      if (restoreFocus) trigger.focus();
      item.classList.remove('is-open');
      item.classList.add('is-closed');
      setExpanded(false);
      stopVideos();
    };

    item.addEventListener('pointerenter', () => {
      window.clearTimeout(closeTimer);
      openTimer = window.setTimeout(open, 110);
    });
    item.addEventListener('pointerleave', () => {
      window.clearTimeout(openTimer);
      closeTimer = window.setTimeout(() => {
        item.classList.remove('is-open', 'is-closed');
        setExpanded(false);
        stopVideos();
      }, 140);
    });
    item.addEventListener('focusin', () => {
      if (!item.classList.contains('is-closed')) open();
    });
    item.addEventListener('focusout', (event) => {
      if (item.contains(event.relatedTarget)) return;
      item.classList.remove('is-open', 'is-closed');
      setExpanded(false);
      stopVideos();
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close({ restoreFocus: true });
        return;
      }

      if (event.key !== 'ArrowDown' && event.key !== 'Enter' && event.key !== ' ') return;
      if (trigger.tagName === 'A' && event.key !== 'ArrowDown') return;
      event.preventDefault();
      open();
      menu.querySelector('.legal-mega-menu__category')?.focus();
    });

    if (trigger.tagName === 'BUTTON') {
      trigger.addEventListener('click', () => {
        open();
        menu.querySelector('.legal-mega-menu__category')?.focus();
      });
    }

    closeButton?.addEventListener('click', () => close({ restoreFocus: true }));
    menu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      close({ restoreFocus: true });
    });
  };

  const initialiseAll = (root = document) => {
    if (root.matches?.('[data-legal-mega-item]')) initialiseMegaMenuItem(root);
    root.querySelectorAll?.('[data-legal-mega-item]').forEach(initialiseMegaMenuItem);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();

(() => {
  const body = document.body;
  if (!body?.matches('.template-index, .template-suffix-notre-histoire, .template-suffix-nos-engagements')) return;

  let frame;
  const updateBannerReveal = () => {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const hero = body.classList.contains('template-index')
      ? document.querySelector('[data-legal-immersive-hero]')
      : document.querySelector('#MainContent .legal-editorial-hero');
    // The banner adds height above the hero when it opens. Ignore that height
    // so its own reveal cannot move the threshold back across the viewport.
    const bannerHeight = header.querySelector('.legal-header-value-bar')?.getBoundingClientRect().height || 0;
    const showBanner = !hero || hero.getBoundingClientRect().bottom - bannerHeight <= 0;
    if (header.classList.contains('legal-header-after-hero') === showBanner) return;

    header.classList.toggle('legal-header-after-hero', showBanner);
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  };

  const scheduleUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = null;
      updateBannerReveal();
    });
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  document.addEventListener('transitionend', (event) => {
    if (!event.target.classList?.contains('legal-header-value-bar') || event.propertyName !== 'max-height') return;
    const header = event.target.closest('.section-header');
    if (header) document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  });
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('shopify:section:unload', scheduleUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBannerReveal, { once: true });
  } else {
    updateBannerReveal();
  }
})();
